import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="portfolio-entry"
export default class PortfolioEntryController extends Controller {

	static targets = [
		'form',
		'contentInput',
		'contentSection',
		'cell',
		'cellTemplate',
		'statusBubble',
		'statusIcon',
		'statusText',
		'cellToolsTemplate'
	]

	connect() {
	}

	cellTargetConnected(target) {
		target.classList.add('editing')

		if (!target.querySelector('.portfolio-entry-cell-tools')) {
			target.prepend(this.cellToolsTemplateTarget.content.cloneNode(true))
		}

		const ckElement = target.querySelector('.ck.ck-content')
		ckElement.classList.add('ck-editor__editable_inline')
		ckElement.setAttribute('data-ckeditor-inline-target', 'editor')
		ckElement.setAttribute('data-controller', 'ckeditor-inline')
	}

	contentSectionTargetConnected(_target) {
		console.log('contentSectionTarget connected')
	}

	addRow(event) {
		const columnCount = Number.parseInt(event.currentTarget.dataset.columnCount)
		const contentToAdd = this.createRowWithColumns(columnCount)

		if (Array.isArray(contentToAdd)) {
			contentToAdd.forEach(content => this.contentSectionTarget.appendChild(content))
		} else {
			this.contentSectionTarget.appendChild(contentToAdd)
		}
	}

	cellDragStart(_event) {
		for (const cell of this.cellTargets) {
			cell.classList.add('dragging')
			cell.querySelector('.ck.ck-content').removeAttribute('contenteditable')
		}
	}

	cellDragEnd(_event) {
		for (const cell of this.cellTargets) {
			cell.classList.remove('dragging')
			cell.querySelector('.ck.ck-content').setAttribute('contenteditable', 'true')
		}
	}

	createRowWithColumns(columnCount) {
		if (columnCount == 1) {
			const newColumnElement = this.createCellElement()
			const portfolioEntryElement = newColumnElement.querySelector('.portfolio-entry-cell')
			portfolioEntryElement.classList.add('col-12')
			portfolioEntryElement.setAttribute('data-col-class', 'col-12')
			return newColumnElement
		} else if (columnCount == 2) {
			const newColumnElements = []
			for (let i = 0; i < 2; i++) {
				const newColumnElement = this.createCellElement()
				const portfolioEntryElement = newColumnElement.querySelector('.portfolio-entry-cell')
				portfolioEntryElement.classList.add('col-6')
				portfolioEntryElement.setAttribute('data-col-class', 'col-6')
				newColumnElements.push(newColumnElement)
			}
			return newColumnElements
		} else if (columnCount == 3) {
			const newColumnElements = []
			for (let i = 0; i < 3; i++) {
				const newColumnElement = this.createCellElement()
				const portfolioEntryElement = newColumnElement.querySelector('.portfolio-entry-cell')
				portfolioEntryElement.classList.add('col-4')
				portfolioEntryElement.setAttribute('data-col-class', 'col-4')
				newColumnElements.push(newColumnElement)
			}
			return newColumnElements
		}
	}

	createCellElement() {
		return this.cellTemplateTarget.content.cloneNode(true)
	}

	onSubmit(_event) {
		// remove previous content input form elements, we're about to append a new one.
		this.contentInputTargets.forEach(input => input.remove())

		const formattedCells = this.cellTargets.map(cell => this.formatCell(cell).outerHTML)
		const formattedContent = formattedCells.join("\n")

		const newInput = document.createElement('input')
		newInput.name = 'portfolio_entry[content]'
		newInput.type = 'hidden'
		newInput.value = formattedContent
		newInput.setAttribute('data-portfolio-entry-target', 'contentInput')

		this.formTarget.append(newInput)
	}

	delaySubmit(_event) {
		if (this.submitTimer) clearTimeout(this.submitTimer)
		//this.submitTimeout = setTimeout(() => { this.formTarget.requestSubmit() }, 500)
		this.submitTimer = setTimeout(() => { this.submit()  }, 800)
	}

	submit() {
		this.statusBubbleTarget.style.opacity = 1.0
		this.statusIconTarget.classList.add('fa-spinner', 'fa-spin')
		this.statusIconTarget.classList.remove('fa-check')
		this.statusIconTarget.parentNode.classList.remove('text-success')
		this.statusTextTarget.innerHTML = 'Saving...'
		this.formTarget.requestSubmit()
	}

	formatCell(cell) {

		const cellCopy = cell.cloneNode(true)

		cellCopy.classList.remove('editing')

		cellCopy
			.querySelectorAll('.portfolio-entry-cell-tools')
			.forEach(element => element.remove())

		// Get the raw content HTML using the CKEditor getData() method. Getting the ckeditor object is only possible
		// from the cell element, not cellCopy. If CKEditor is actively being edited, it will have many of the tools
		// and editor-specific css present in the .ck-content element. We don't want to save or show that later.
		const editorElement = cell.querySelector('.ck-content')
		const ckEditorInlineController = this.application.getControllerForElementAndIdentifier(editorElement, 'ckeditor-inline')
		const ckEditor = ckEditorInlineController.editor
		const	rawContent = ckEditor.getData()

		const newContentElement = document.createElement('div')
		newContentElement.classList.add('ck', 'ck-content', 'ck-editor__editable_inline')
		newContentElement.innerHTML = rawContent
		cellCopy.querySelector('.ck-content').replaceWith(newContentElement)

		return cellCopy
	}
}
